module.exports = __webpack_public_path__ + "img/3.7dfb1837.jpg";